import { useCallback, useEffect, useState } from 'react'

import { subscribeBoggleUnviewedChanged } from '~/boggle/progress/unviewedNotifications'
import { getBoggleProgressRepository } from '~/boggle/progress/webProgressRepository'

export function useBoggleUnviewedBadgeButtonCount() {
  const [count, setCount] = useState(0)

  const refresh = useCallback(() => {
    void getBoggleProgressRepository()
      .getUnviewedBadges()
      .then(entries => {
        setCount(entries.length)
      })
      .catch(error => {
        console.error('[boggle] failed to load unviewed badge count', error)
      })
  }, [])

  useEffect(() => {
    refresh()
    return subscribeBoggleUnviewedChanged(refresh)
  }, [refresh])

  const clearCount = useCallback(() => {
    setCount(0)
  }, [])

  return { clearCount, count, refresh }
}

export function useBoggleUnviewedAchievementTierCount() {
  const [count, setCount] = useState(0)

  const refresh = useCallback(() => {
    void getBoggleProgressRepository()
      .getUnviewedAchievementTiers()
      .then(entries => {
        setCount(entries.length)
      })
      .catch(error => {
        console.error('[boggle] failed to load unviewed achievement count', error)
      })
  }, [])

  useEffect(() => {
    refresh()
    return subscribeBoggleUnviewedChanged(refresh)
  }, [refresh])

  const clearCount = useCallback(() => {
    setCount(0)
  }, [])

  return { clearCount, count, refresh }
}

export function useBoggleUnviewedWordButtonCount() {
  const [count, setCount] = useState(0)

  const refresh = useCallback(() => {
    void getBoggleProgressRepository()
      .getUnviewedWords()
      .then(entries => {
        setCount(entries.length)
      })
      .catch(error => {
        console.error('[boggle] failed to load unviewed word count', error)
      })
  }, [])

  useEffect(() => {
    refresh()
    return subscribeBoggleUnviewedChanged(refresh)
  }, [refresh])

  const clearCount = useCallback(() => {
    setCount(0)
  }, [])

  return { clearCount, count, refresh }
}
